import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot } from '@angular/router';

import { AuthService } from '../../services/auth.service';

// Checks if user has an organization ID that matches the route param
@Injectable()
export class OrganizationGuardService  {

  constructor(public service: AuthService, public router: Router) { }

  canActivate(route: ActivatedRouteSnapshot): boolean {

    const user = this.service.User;

    if (user.organizationId === route.params.organizationId) {
      return true;
    } else {
      this.router.navigate(['/home/unauthorized']);
      return false;
    }      
  }

}
